/**
 * @file Automatically generated by barrelsby.
 */

export * from './persistence.service';
